<template>
  <div
    class="trezo-card bg-primary-600 bg-left-bottom bg-no-repeat bg-contain mb-[25px] p-[20px] md:p-[25px] rounded-md"
    style="background-image: url(assets/images/portfolio-bg.jpg)"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0 text-white">Portfolio</h5>
      </div>
    </div>
    <div class="trezo-card-content relative z-[1] md:mt-[29px]">
      <div class="flex items-center mb-[20px] md:mb-[28px]">
        <img
          src="@/assets/images/icons/total-balance.svg"
          alt="total-balance"
        />
        <div class="ltr:ml-[10px] rtl:mr-[10px]">
          <span class="block uppercase text-white"> Total balance </span>
          <h4
            class="mb-0 text-white font-semibold mt-[6px] text-[18px] md:text-[20px]"
          >
            $78,350.00
            <span
              class="font-medium relative text-base ltr:ml-[3px] rtl:mr-[3px] ltr:pl-[25px] rtl:pr-[25px] text-success-100"
            >
              <i
                class="material-symbols-outlined absolute !text-[20px] ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
              >
                trending_up
              </i>
              +2.3%
            </span>
          </h4>
        </div>
      </div>
      <div class="table-responsive overflow-x-auto">
        <table class="w-full">
          <thead class="text-white">
            <tr>
              <th
                class="font-medium text-xs ltr:text-left rtl:text-right px-[14px] pb-[7px] whitespace-nowrap ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0"
              >
                Coin
              </th>
              <th
                class="font-medium text-xs text-center px-[14px] pb-[7px] whitespace-nowrap ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0"
              >
                Amount
              </th>
              <th
                class="font-medium text-xs ltr:text-right rtl:text-left px-[14px] pb-[7px] whitespace-nowrap ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0"
              >
                Total Value
              </th>
            </tr>
          </thead>
          <tbody class="text-white">
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                Bitcoin <span class="text-xs font-normal">(BTC)</span>
              </td>
              <td
                class="font-medium text-center whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                0.50 BTC
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                $13,500
              </td>
            </tr>
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                Ethereum <span class="text-xs font-normal">(ETH)</span>
              </td>
              <td
                class="font-medium text-center whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                5.00 ETH
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                $8,750
              </td>
            </tr>
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                Binance <span class="text-xs font-normal">(BNB)</span>
              </td>
              <td
                class="font-medium text-center whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                100 SOL
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                $3,500
              </td>
            </tr>
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                Tether <span class="text-xs font-normal">(USDT)</span>
              </td>
              <td
                class="font-medium text-center whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                10 BNB
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                $2,500
              </td>
            </tr>
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                XRP <span class="text-xs font-normal">(XRP)</span>
              </td>
              <td
                class="font-medium text-center whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                1,000 ADA
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[14px] ltr:first:pl-0 rtl:first:pr-0 ltr:last:pr-0 rtl:last:pl-0 py-[10px] border-b !border-primary-400"
              >
                $250
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ltr:text-right rtl:text-left">
        <a
          href="#"
          class="inline-block px-[12px] py-[4px] rounded-md text-white font-medium border border-primary-400 transition-all hover:bg-primary-400 mt-[20px] md:mt-[28px]"
        >
          <span class="inline-block relative ltr:pr-[17px] rtl:pl-[17px]">
            View All Portfolio
            <i
              class="ri-arrow-right-s-line absolute ltr:-right-[6px] rtl:-left-[6px] text-[20px] top-1/2 -translate-y-1/2"
            ></i>
          </span>
        </a>
      </div>
      <div
        class="absolute ltr:right-0 rtl:left-0 -top-[55px] -z-[1] hidden md:block"
      >
        <img src="@/assets/images/sphere-bowl.png" alt="sphere-bowl" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Portfolio",
});
</script>
